module.exports = __webpack_public_path__ + "img/home.a43ab1cd.png";